export const RANK_NAMES = [
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "jack",
    "queen",
    "king",
    "1",
];
export const COLOR_NAMES = ["club", "diamond", "heart", "spade"];
